"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _amsLogout = _interopRequireDefault(require("../wrappers/ams-logout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _amsLogout["default"])(function (_ref) {
  var logout = _ref.logout,
      redirectTo = _ref.redirectTo;

  _react["default"].useEffect(function () {
    logout();
  }, [logout]);

  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: redirectTo
  });
});

exports["default"] = _default;